import React from 'react'
import { BaseBottomSheet } from '../ui/BaseBottomSheet'
import { BottomSheetOptions } from '../ui/BottomSheetOptions'
import i18next from 'i18next'

type Props = {
    open: boolean
    onClose: () => void
    onDelete: () => void
    onEdit: () => void
}

export function CommentOptions({ open, onClose, onDelete, onEdit }: Props) {
    return (
        <BaseBottomSheet title={'Options'} isOpen={open} onClose={onClose} size={'auto'}>
            <BottomSheetOptions
                options={[
                    {
                        optionLabel: i18next.t('appcore:common.edit'),
                        iconName: 'edit',
                        onClick: async () => {
                            onEdit()
                            onClose()
                        },
                    },
                    {
                        optionLabel: i18next.t('appcore:common.delete'),
                        iconName: 'bin',
                        labelStyles: { color: 'var(--red-500)' },
                        onClick: async () => {
                            onDelete()
                            onClose()
                        },
                    },
                ]}
            />
        </BaseBottomSheet>
    )
}
